<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.mesOrders'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>
        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.categoryId"
            :placeholder="$t('product.category')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>

        <date-range
          v-model="searchForm"
          type="datetime"
          field="createAt"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="handOver"
          :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
        />
        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown menu-align="start" trigger="click" class="mgr10">
              <el-button type="default" size="mini">
                {{ $t("action.addGroup") }}
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="group of groups" :key="group">
                  <div @click="batchAddGroup(group)" :loading="joinGroupDoing">
                    {{ group }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              v-if="Permit.canActionsChargeEdition('mesOrderDispatch')"
              menu-align="start"
              trigger="click"
              class="mgr10"
            >
              <el-button type="warning" size="mini">
                转产线
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="factory of factories"
                  :key="factory.id"
                >
                  <div @click="changeFactory(factory)">{{ factory.name }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button type="success" size="mini" @click="batchEditCostPrice">
              {{ $t("text.edit") }}{{ $t("orderMes.price") }}
            </el-button>

            <el-button
              v-if="
                Permit.extendModels().includes('mms') &&
                Permit.canActions('mesOrderDispatch')
              "
              type="primary"
              size="mini"
              @click="accountiMaterials"
              class="button-blue"
              >{{ $t("menu.calculates") }}</el-button
            >

            <!-- <el-button
              v-if="Permit.extendModels().includes('mms')"
              type="default"
              size="mini"
              @click="print"
              >生产通知单打印</el-button
            > -->

            <el-dropdown
              v-if="Permit.extendModels().includes('mms')"
              class="mgl10"
              @command="print2"
            >
              <el-button type="default" size="mini">
                生产通知单打印
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.printChecked") }}(带物料)</el-dropdown-item
                >
                <el-dropdown-item command="search">
                  {{ $t("action.printSearch") }}(带物料)
                </el-dropdown-item>
                <el-dropdown-item command="checkedNoMaterial">
                  {{ $t("action.printChecked") }}(不带物料)</el-dropdown-item
                >
                <el-dropdown-item command="searchNoMaterial">
                  {{ $t("action.printSearch") }}(不带物料)
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}</el-dropdown-item
                >
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="rowBgColor"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="groupJsons"
          :title="$t('action.group')"
          min-width="80"
        >
          <template v-slot="{ row, rowIndex }">
            <span v-if="row.groupJsons != null && row.groupJsons != ''">
              <el-tag
                :key="groupIndex"
                v-for="(group, groupIndex) in JSON.parse(row.groupJsons)"
                closable
                size="mini"
                type="info"
                @close="deleteGroup(row, rowIndex, group, groupIndex)"
              >
                <raw-html-limit-number :content="group" :number="4" />
              </el-tag>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              <s v-if="row.retrieveAt != null">{{ row.serialNo }}</s>
              <span v-if="row.retrieveAt == null">
                <s v-if="row.jyOrderCancelAt != null" class="grey">
                  {{ row.serialNo }}
                </s>
                <span v-if="row.jyOrderCancelAt == null">
                  {{ row.serialNo }}
                </span>
              </span>
            </a>

            <div class="font10">{{ row.workOrderSn }}</div>
            <div v-if="row.innerSerialNo != null" class="font10">
              {{ row.innerSerialNo }}
            </div>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("mesOrderStates." + row.workflowState) }}
              </state-label>
              <span v-if="row.pauseAt != null" class="orange font10">
                {{ $t("text.stop") }}
              </span>
              <a
                v-if="row.sizeTemplate"
                class="font10"
                :href="row.sizeTemplate"
                target="_blank"
              >
                {{ $t("orderMes.sizeTemplate") }}
              </a>
              <span v-if="row.type != null" class="font10">
                {{ $t("mesOrderTypes." + row.type) }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="factoryName"
          :title="$t('menu.factories')"
          min-width="100"
        />
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div class="font10">
              {{ row.terminalCustomerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <!-- row.workflowState == 'newly' && -->
            <i
              v-if="
                !['processed', 'finished', 'canceled'].includes(
                  row.workflowState
                ) && Permit.canActionsChargeEdition('mesOrderEdit')
              "
              slot="reference"
              class="el-icon-edit"
              @click="editRemark(row, rowIndex)"
            />
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
            <div class="font10">
              {{ $t("orderMes.mmsRemark") }}:
              <i
                v-if="
                  !['processed', 'finished', 'canceled'].includes(
                    row.workflowState
                  ) && Permit.canActionsChargeEdition('mesOrderEdit')
                "
                slot="reference"
                class="el-icon-edit"
                @click="editMaterialRemark(row, rowIndex)"
              />
              <raw-html-limit-number
                :content="row.materialRemark"
                :number="12"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActions('globalCostPrice')"
          field="costPrice"
          :title="$t('orderMes.price')"
          min-width="80"
        >
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="Permit.canActionsChargeEdition('mesOrderEdit')"
              slot="reference"
              class="el-icon-edit"
              @click="editCostPrice(row, rowIndex)"
            />
            {{ row.costPrice | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
            <div
              v-if="
                ['newly', 'processing'].includes(row.workflowState) &&
                row.handOverAt != null
              "
              class="font10"
              :class="
                Util.dateDiff(row.handOverAt, new Date()) > 0 ? '' : 'red'
              "
            >
              {{ $t("text.handOverAtDateMinus")
              }}{{ Util.dateDiff(row.handOverAt, new Date()) }}天
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.handle')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.ownerName }}
            <div class="font10">{{ row.handleDepart }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="90"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                row.workflowState == 'newly' &&
                Permit.canActionsChargeEdition('mesOrderEdit')
              "
              type="text"
              size="mini"
              @click="edit(row)"
              >{{ $t("text.edit") }}
            </el-button>

            <el-button
              v-if="
                ['newly', 'dispatched', 'processing'].includes(
                  row.workflowState
                ) &&
                row.workflowState !== 'canceled' &&
                row.jyOrderCancelAt != null &&
                Permit.canActionsChargeEdition('mesOrderCancel')
              "
              type="text"
              size="mini"
              @click="cancel(row)"
              >{{ $t("order.cancel") }}</el-button
            >
            <div>
              <el-button
                v-if="
                  ['dispatched', 'processing'].includes(row.workflowState) &&
                  row.pauseAt == null &&
                  Permit.canActionsChargeEdition('mesOrderStop')
                "
                type="text"
                size="mini"
                @click="pause(row)"
                >{{ $t("action.pause") }}</el-button
              >
            </div>
            <div>
              <el-button
                v-if="
                  row.pauseAt != null &&
                  Permit.canActionsChargeEdition('mesOrderReProcess') &&
                  row.cancelAt == null
                "
                type="text"
                size="mini"
                @click="reManufacture(row)"
                >{{ $t("action.reManufacture") }}</el-button
              >
            </div>
            <el-button
              v-if="
                ['dispatched', 'processing'].includes(row.workflowState) &&
                Permit.canActionsChargeEdition('mesOrderReDispatch')
              "
              type="text"
              size="mini"
              @click="reDispatch(row)"
              >{{ $t("action.reDispatch") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view')"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :uuid="currentRowUuid" :id="currentRowId" />
    </drawer>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj">
        <fieldset v-if="specJsonArrEdit.length != 0" class="mgb15">
          <legend>{{ $t("product.specJson") }}</legend>
          <el-row :gutter="20">
            <el-col
              v-for="(spec, index) in specJsonArrEdit"
              :key="index"
              :span="8"
              class="mb10"
            >
              <el-input v-model.trim="spec.value" size="small">
                <template slot="prepend">
                  <div>
                    <raw-html-limit-number :content="spec.name" :number="6" />
                  </div>
                </template>
              </el-input>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("product.craftwork") }}</legend>
          <tinymce-editor
            ref="editor"
            v-model="editObj.craftwork"
            :height="300"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 备注-->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editRemarkObj">
        <fieldset>
          <tinymce-editor
            ref="editor"
            v-model="editRemarkObj.remark"
            :height="150"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 物料备注-->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editMaterialRemarkDF"
      width="30%"
    >
      <el-form ref="editMaterialRemarkObjForm" :model="editMaterialRemarkObj">
        <fieldset>
          <el-input
            v-model="editMaterialRemarkObj.materialRemark"
            type="textarea"
            :rows="5"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editMaterialRemarkDoing"
          size="small"
          @click="editMaterialRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editMaterialRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editCostPriceDF"
      width="30%"
    >
      <el-form ref="editCostPriceObjForm" :model="editCostPriceObj">
        <el-form-item>
          <el-input
            v-model="editCostPriceObj.costPrice"
            size="small"
            :placeholder="$t('orderMes.price')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editCostPriceDoing"
          size="small"
          @click="editCostPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editCostPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 取消 -->
    <el-dialog
      :title="$t('order.cancel')"
      :close-on-click-modal="false"
      :visible.sync="cancelDF"
      width="30%"
    >
      <el-form ref="cancelForm" :model="cancelObj">
        <el-form-item>
          <el-input
            v-model="cancelObj.cancelReason"
            type="textarea"
            :rows="3"
            :placeholder="$t('order.cancelReason')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="cancelDoing"
          size="small"
          @click="cancelSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="cancelDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.reDispatch')"
      :close-on-click-modal="false"
      :visible.sync="handmadeDispatchDF"
      width="60%"
    >
      <div class="red mb10">
        注意：重新派单后，此订单下的工单、生产记录、出货记录、尾查记录、返工记录等数据将彻底清除，请谨慎操作
      </div>
      <el-form
        ref="handmadeDispatchForm"
        :model="handmadeDispatchObj"
        label-width="80px"
      >
        <el-row>
          <el-col :span="9">
            <el-form-item
              :label="$t('orderMes.dispatchType')"
              :prop="'type'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('orderMes.dispatchType')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-radio
                size="small"
                v-model="handmadeDispatchObj.type"
                label="single"
              >
                一件一包
              </el-radio>
              <el-radio
                size="small"
                v-model="handmadeDispatchObj.type"
                label="whole"
              >
                一单一包
              </el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('menu.phaseTemplates')"
              :prop="'_selectedPhaseTemplateId'"
            >
              <el-select
                size="small"
                v-model="handmadeDispatchObj._selectedPhaseTemplateId"
                filterable
                @change="selectPhaseTemplate"
              >
                <el-option
                  v-for="phaseTemplate in phaseTemplates"
                  :key="phaseTemplate.id"
                  :label="phaseTemplate.name"
                  :value="phaseTemplate.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="$t('orderMes.handOverAtAdvanceDay')"
              :prop="'day'"
            >
              <el-input
                size="small"
                v-model="handmadeDispatchObj.day"
                placeholder="天"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <vxe-table
          v-if="phaseTemplatePhases.length != 0"
          :data="phaseTemplatePhases"
          size="mini"
          resizable
          round
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column width="60px">
            <template v-slot="{ row, rowIndex }">
              <i
                v-if="rowIndex != 0"
                class="el-icon-top mgr10"
                @click="swapSequence(row, rowIndex, 'up')"
              ></i>
              <i
                v-if="rowIndex + 1 != phaseTemplatePhases.length"
                class="el-icon-bottom"
                @click="swapSequence(row, rowIndex, 'down')"
              ></i>
            </template>
          </vxe-table-column>
          <vxe-table-column field="phaseName" :title="$t('menu.phases')" />
          <vxe-table-column
            field="phaseHour"
            :title="$t('phaseTemplate.phaseHour')"
          >
            <template v-slot="{ row }">
              <el-input
                size="mini"
                v-model="row.phaseHour"
                placeholder="必填"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="period" :title="$t('phaseTemplate.period')">
            <template v-slot="{ row }">
              <el-input size="mini" v-model="row.period" placeholder="必填" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="inspect"
            :title="$t('phaseTemplate.inspect')"
            width="60px"
          >
            <template v-slot="{ row }">
              <el-checkbox v-model="row.inspect" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50px"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" size="mini" @click="remove(row, rowIndex)">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="handmadeDispatchDoing"
          size="small"
          @click="handmadeDispatchSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="handmadeDispatchDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('menu.calculates')"
      :close-on-click-modal="false"
      :visible.sync="accountiMaterialsDF"
      width="80%"
    >
      <vxe-table
        :data="datas"
        :loading="loading"
        id="materialTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="image"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.image" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('material.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div class="font10">{{ row.name }} {{ row.subjectName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('material.color')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.color }}
            <div class="font10">{{ row.colorNo }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        />
        <vxe-table-column
          field="requireQty"
          :title="$t('material.requireQty')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.requireQty }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="storeQuantity"
          :title="$t('material.storeQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.inventoryQty }}{{ row.unit }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="inventories"
          :title="$t('inventory.inventoryInfo')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <span v-if="row.inventorie && row.inventories.length != 0">
              <div v-for="i of row.inventories" :key="i.id" class="font10">
                {{ i.warehouseName }}({{ i.shelf }})&nbsp;{{ i.storeQuantity
                }}{{ i.material.unit }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="loadingQty"
          :title="$t('material.loadingQty')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.loadingQty }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="unQualityQty"
          :title="$t('material.unQualityQty')"
          min-width="90"
        >
          <template v-slot="{ row }">
            {{ row.unQualityQty || 0 }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="unStorageQty"
          :title="$t('material.unStorageQty')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.unStorageQty || 0 }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deficitQty"
          :title="$t('material.deficitQty')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span :class="row.deficitQty < 0 ? 'red' : ''">
              {{ row.deficitQty }}{{ row.unit }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="accountiMaterialsDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printSummaryDF"
      width="50%"
    >
      <vxe-table
        :data="printSummaryDatas"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }"> {{ row.serialNo }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="customerProductNoArrs"
          :title="$t('order.customerProductNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.customerProductNoArrs.join(";") }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="60"
        />

        <vxe-table-column
          field="sizeArrs"
          :title="$t('product.size')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <div v-for="(sizeArr, index) of row.sizeArrs" :key="index">
              {{ sizeArr.size || "无" }}: {{ sizeArr.quantity
              }}{{ sizeArr.unit }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        />
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          size="small"
          @click="printFun('printSummaryDiv')"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printSummaryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <!--  -->
    <div id="printSummaryDiv" style="display: none">
      <div style="width: 100%; text-align: left">
        <div style="text-align: center; font-size: 20px; margin-bottom: 10px">
          生产通知单
        </div>
        <div
          v-for="(group, groupIndex) in printSummaryDatasGroup"
          :key="groupIndex"
          :style="
            'font-size: 14px;' +
            (groupIndex == 0 ? '' : 'page-break-before: always;')
          "
        >
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              word-wrap: break-word;
              word-break: break-all;
            "
          >
            <tr v-if="groupIndex == 0 && bargain != null">
              <td style="padding: 5px 0" colspan="4">
                {{ $t("bargain.serialNo") }}：{{ bargain.serialNo }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="
                  handOverAts.length !== 1
                    ? 4 + printSummarySizes.length
                    : 3 + printSummarySizes.length
                "
              ></td>
            </tr>
            <tr v-if="groupIndex == 0 && bargain != null">
              <td style="padding: 5px 0" colspan="4">
                {{ $t("menu.customers") }}：{{ bargain.customerName }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="
                  handOverAts.length !== 1
                    ? 4 + printSummarySizes.length
                    : 3 + printSummarySizes.length
                "
              >
                生产日期：{{ bargain.createAt }}
                <span v-if="handOverAts.length == 1" style="margin-left: 10px">
                  {{ $t("text.handOverAt") }}：
                  <span v-if="handOverAts.length != 0">
                    {{ handOverAts[0] }}
                  </span>
                </span>
              </td>
            </tr>
            <tr style="text-align: center">
              <td style="border: 1px solid black" rowspan="2">
                <strong>订单项</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("product.productNo") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>客号</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("menu.materials") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("product.color") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>件数</strong>
              </td>
              <td
                style="border: 1px solid black"
                :colspan="printSummarySizes.length"
              >
                <strong>{{ $t("product.size") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("text.remark") }}</strong>
              </td>
              <td
                v-if="handOverAts.length !== 1"
                style="border: 1px solid black"
                rowspan="2"
              >
                <strong>{{ $t("text.handOverAt") }}</strong>
              </td>
            </tr>
            <tr style="text-align: center">
              <td
                style="border: 1px solid black; width: 60px; height: 26px"
                v-for="(size, sizeIndex) of printSummarySizes"
                :key="sizeIndex"
              >
                {{ size }}
              </td>
            </tr>
            <span v-for="(cr, index) in group" :key="index">
              <tr style="text-align: center">
                <td
                  style="
                    border: 1px solid black;
                    width: 100px;
                    text-align: left;
                  "
                >
                  {{ cr.serialNo }}
                </td>
                <td style="border: 1px solid black; width: 100px">
                  {{ cr.productNo }}
                </td>
                <td style="border: 1px solid black; width: 100px">
                  {{ cr.customerProductNoArrs.join(";") }}
                </td>
                <td
                  style="
                    border: 1px solid black;
                    width: 200px;
                    text-align: left;
                  "
                >
                  {{ cr.bomStr }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ cr.color }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ cr.subQuantity }}{{ cr.unit }}
                </td>
                <td
                  style="border: 1px solid black; width: 60px"
                  v-for="(size, sizeIndex) of printSummarySizes"
                  :key="sizeIndex"
                >
                  {{ printComputeSizeQty(size, cr) }}
                </td>
                <td
                  style="
                    border: 1px solid black;
                    width: 200px;
                    text-align: left;
                  "
                >
                  <raw-html
                    :content="cr.customerProductNoArrs.join(';')"
                    type="richText"
                  />
                </td>
                <td
                  style="border: 1px solid black; width: 80px"
                  v-if="handOverAts.length !== 1"
                >
                  {{ cr.handOverAt }}
                </td>
              </tr>
            </span>
            <tr
              style="text-align: center"
              v-if="groupIndex == printSummaryDatasGroup.length - 1"
            >
              <td style="padding: 5px 0" colspan="4"></td>
              <td style="padding: 5px 0">件数：</td>
              <td style="padding: 5px 0">
                {{ printSummaryQuantity }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="2 + printSummarySizes.length"
              ></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--  -->
    <div id="printSummaryNoMaterialDiv" style="display: none">
      <div style="width: 100%; text-align: left">
        <div style="text-align: center; font-size: 20px; margin-bottom: 10px">
          生产通知单
        </div>
        <div
          v-for="(group, groupIndex) in printSummaryDatasGroup"
          :key="groupIndex"
          :style="
            'font-size: 14px;' +
            (groupIndex == 0 ? '' : 'page-break-before: always;')
          "
        >
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              word-wrap: break-word;
              word-break: break-all;
            "
          >
            <tr v-if="groupIndex == 0 && bargain != null">
              <td style="padding: 5px 0" colspan="3">
                {{ $t("bargain.serialNo") }}：{{ bargain.serialNo }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="
                  handOverAts.length !== 1
                    ? 4 + printSummarySizes.length
                    : 3 + printSummarySizes.length
                "
              ></td>
            </tr>
            <tr v-if="groupIndex == 0 && bargain != null">
              <td style="padding: 5px 0" colspan="3">
                {{ $t("menu.customers") }}：{{ bargain.customerName }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="
                  handOverAts.length !== 1
                    ? 4 + printSummarySizes.length
                    : 3 + printSummarySizes.length
                "
              >
                生产日期：{{ bargain.createAt }}
                <span v-if="handOverAts.length == 1" style="margin-left: 10px">
                  {{ $t("text.handOverAt") }}：
                  <span v-if="handOverAts.length != 0">
                    {{ handOverAts[0] }}
                  </span>
                </span>
              </td>
            </tr>
            <tr style="text-align: center">
              <td style="border: 1px solid black" rowspan="2">
                <strong>订单项</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("product.productNo") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>客号</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("product.color") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>件数</strong>
              </td>
              <td
                style="border: 1px solid black"
                :colspan="printSummarySizes.length"
              >
                <strong>{{ $t("product.size") }}</strong>
              </td>
              <td style="border: 1px solid black" rowspan="2">
                <strong>{{ $t("text.remark") }}</strong>
              </td>
              <td
                v-if="handOverAts.length !== 1"
                style="border: 1px solid black"
                rowspan="2"
              >
                <strong>{{ $t("text.handOverAt") }}</strong>
              </td>
            </tr>
            <tr style="text-align: center">
              <td
                style="border: 1px solid black; width: 60px; height: 26px"
                v-for="(size, sizeIndex) of printSummarySizes"
                :key="sizeIndex"
              >
                {{ size }}
              </td>
            </tr>
            <span v-for="(cr, index) in group" :key="index">
              <tr style="text-align: center">
                <td
                  style="
                    border: 1px solid black;
                    width: 100px;
                    text-align: left;
                  "
                >
                  {{ cr.serialNo }}
                </td>
                <td style="border: 1px solid black; width: 100px">
                  {{ cr.productNo }}
                </td>
                <td style="border: 1px solid black; width: 100px">
                  {{ cr.customerProductNoArrs.join(";") }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ cr.color }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ cr.subQuantity }}{{ cr.unit }}
                </td>
                <td
                  style="border: 1px solid black; width: 60px"
                  v-for="(size, sizeIndex) of printSummarySizes"
                  :key="sizeIndex"
                >
                  {{ printComputeSizeQty(size, cr) }}
                </td>
                <td
                  style="
                    border: 1px solid black;
                    width: 200px;
                    text-align: left;
                  "
                >
                  <raw-html
                    :content="cr.customerProductNoArrs.join(';')"
                    type="richText"
                  />
                </td>
                <td
                  style="border: 1px solid black; width: 80px"
                  v-if="handOverAts.length !== 1"
                >
                  {{ cr.handOverAt }}
                </td>
              </tr>
            </span>
            <tr
              style="text-align: center"
              v-if="groupIndex == printSummaryDatasGroup.length - 1"
            >
              <td style="padding: 5px 0" colspan="3"></td>
              <td style="padding: 5px 0">件数：</td>
              <td style="padding: 5px 0">
                {{ printSummaryQuantity }}
              </td>
              <td
                style="padding: 5px 0"
                :colspan="2 + printSummarySizes.length"
              ></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import TinymceEditor from "@/components/TinymceEditor";
import CustomerSearch from "@/components/CustomerSearch";
import RawHtml from "@/components/RawHtml";
import OrderMes from "@/api/orderMes.js";
import Brand from "@/api/brand.js";
import Category from "@/api/category.js";
import Enumeration from "@/api/enumeration.js";
import Factory from "@/api/factory.js";
import UserFactory from "@/api/userFactory.js";
import WorkOrder from "@/api/workOrder.js";
import PhaseTemplate from "@/api/phaseTemplate.js";
import Product from "@/api/product.js";
import Phase from "@/api/phase.js";
import Material from "@/api/material.js";
import Bargain from "@/api/bargain.js";
import Size from "@/api/size.js";
import Show from "./show.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    TinymceEditor,
    Show,
    CustomerSearch,
    RawHtml,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: OrderMes.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: OrderMes.passRange,
          },
          {
            label: this.$t("product.sizeTemplates"),
            items: [
              {
                label: this.$t("sizeTemplateInfos.yes"),
                key: "hasSizeTemplateYes",
                condition: { hasSizeTemplate: "yes" },
              },
              {
                label: this.$t("sizeTemplateInfos.no"),
                key: "hasSizeTemplateNo",
                condition: { hasSizeTemplate: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: OrderMes.states_all.map((s) => {
              return {
                label: this.$t("mesOrderStates." + s),
                key: s,
                condition: { workflowStates: [s] },
              };
            }),
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("action.retrieve"),
                key: "yes",
                condition: { retrieve: "yes" },
              },
              {
                label: this.$t("orderMes.customerCancel"),
                key: "customerCancel",
                condition: { cancelType: "customer" },
              },
            ],
          },
          {
            label: this.$t("text.orderType"),
            items: OrderMes.order_types.map((type) => {
              return {
                label: this.$t("mesOrderTypes." + type),
                key: type,
                condition: { type: type },
              };
            }),
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        keyword: null,
        customerId: null,
        customerName: null,
        createAtStratAt: null,
        createAtEndAt: null,
        handOverStartAt: null,
        handOverEndAt: null,
        handle: null,
        productNo: null,
        color: null,
        size: null,
        categoryId: null,
        specJson: null,
        remark: null,
      },
      categories: [],
      brands: [],
      show: false,
      currentRowId: null,
      currentRowUuid: null,
      //
      groups: [],
      groupsNarrow: [],
      joinGroupDoing: false,
      //
      factories: [],
      userFactories: [],
      mesAuthFactories: [],
      sizes: [],
      //
      // 编辑
      row: null,
      editDF: false,
      editObj: {
        specJson: null,
        craftwork: null,
        remark: null,
      },
      specJsonArrEdit: [],
      editDoing: false,
      //
      currentRowIdx: false,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
      },
      editRemarkDoing: false,
      //
      editMaterialRemarkDF: false,
      editMaterialRemarkObj: {
        materialRemark: null,
      },
      editMaterialRemarkDoing: false,
      //
      editCostPriceType: "batch",
      editCostPriceDF: false,
      editCostPriceObj: {
        costPrice: null,
      },
      editCostPriceDoing: false,

      // 取消
      cancelDF: false,
      cancelObj: {
        id: null,
        cancelReason: null,
      },
      cancelDoing: false,
      // 重新派单
      handmadeDispatchDF: false,
      phaseTemplates: [],
      productPhases: [],
      phaseTemplatePhases: [],
      phases: [],
      handmadeDispatchObj: {
        type: "single",
        ids: [],
        phaseTemplateItems: [],
        _selectedPhaseTemplateId: null,
        day: null,
      },
      handmadeDispatchDoing: false,
      //
      accountiMaterialsDF: false,
      datasAll: [],
      datas: [],
      //
      printSummaryDF: false,
      printSummaryDatas: [],
      printSummarySizes: [],
      printSummaryDatasGroup: [],
      printSummaryQuantity: 0,
      bargain: null,
      handOverAts: [],
      printType: null,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios
      .all([
        Category.findByTenantId(),
        Brand.findByTenantId(),
        Enumeration.findByType("group"),
        Factory.findByTenantId(),
        UserFactory.findByUserId(self.Permit.currentUser().id),
        Size.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          categories,
          brands,
          groups,
          factories,
          userFactories,
          sizes
        ) {
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (groups.data.code === 200) {
            self.groups = JSON.parse(groups.data.entity.itemsJson);
            self.groupsNarrow = self.groups.concat(["none"]);
          } else {
            self.sysError();
          }
          if (factories.status === 200) {
            self.factories = factories.data;
          } else {
            self.sysError();
          }
          if (userFactories.status == 200) {
            self.userFactories = userFactories.data;

            if (self.Permit.currentUser().admin === true) {
              self.mesAuthFactories = self.factories;
            } else {
              const userFactoryIds = self.userFactories.map((u) => u.factoryId);
              self.mesAuthFactories = self.factories.filter((f) =>
                userFactoryIds.includes(f.id)
              );
            }
            self.narrowsFactoriesBrandsGroups();
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    printComputeSizeQty(size, cr) {
      if (size == null || size == "") {
        return;
      }
      let obj = cr.sizeArrs.find((si) => si.size == size);
      if (obj == null) {
        return;
      }
      if (obj !== null && obj.quantity == 0) {
        return;
      }
      return obj.quantity;
    },

    print2(type) {
      const self = this;
      self.printType = type;
      //打印带物料和不带物料的，都是勾选和搜索 所以用包含解决
      if (type.indexOf("checked") != -1) {
        self.print(self.selectRecords);
      } else {
        if (
          JSON.stringify(Util.deleteObjValueIsNull(self.searchForm)) === "{}" &&
          JSON.stringify(Util.deleteObjValueIsNull(self.filters)) === "{}"
        ) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = 500;
        OrderMes.search(data).then(function (res) {
          if (res.status == 200) {
            self.print(res.data.records);
          } else {
            self.sysError();
          }
        });
      }
    },
    print(orders) {
      const self = this;
      if (orders.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      let bargainIds = [];
      let productNoColors = [];
      self.handOverAts = [];
      for (let order of orders) {
        //
        let bargainIdIndex = bargainIds.findIndex((b) => b == order.bargainId);
        if (bargainIdIndex == -1) {
          bargainIds.push(order.bargainId);
        }
        //
        let handOverAtIndex = self.handOverAts.findIndex(
          (h) => h == order.handOverAt
        );
        if (handOverAtIndex == -1) {
          self.handOverAts.push(order.handOverAt);
        }
        //
        let printArrsIndex = productNoColors.findIndex(
          (p) => p.productNo == order.productNo && p.color == order.color
        );
        if (printArrsIndex == -1) {
          productNoColors.push({
            productNo: order.productNo,
            color: order.color,
          });
        }
      }
      if (bargainIds.length != 1 || bargainIds[0] == null) {
        self.$message({
          message: this.$t("prompt.differBargainOrders"),
          type: "warning",
        });
        return;
      }
      self.printSummarySizes = [];
      self.printSummaryDatas = [];
      self.bargain = null;
      Product.batchFindBomByProductInfo(productNoColors).then(function (res) {
        if (res.status == 200) {
          self.computeDatas(orders, res.data);
          self.getBargain(bargainIds[0]);
          self.printSummaryDF = true;
        } else {
          self.sysError();
        }
      });
    },
    computeDatas(orders, productNoColorBoms) {
      const self = this;
      self.printSummaryQuantity = 0;
      self.printSummarySizes = [];
      self.printSummaryDatas = [];
      self.printSummaryDatasGroup = [];
      for (let order of orders) {
        //打印的所有规格
        if (!self.printSummarySizes.includes(order.size)) {
          self.printSummarySizes.push(order.size);
        }
        //打印所有数量合计
        self.printSummaryQuantity =
          self.printSummaryQuantity + Number(order.quantity);
        //
        let printArrsIndex = self.printSummaryDatas.findIndex(
          (p) =>
            p.serialNo == order.serialNo.split("-")[0] &&
            p.productNo == order.productNo &&
            p.color == order.color &&
            p.handOverAt == order.handOverAt
        );
        if (printArrsIndex == -1) {
          self.printSummaryDatas.push({
            serialNo: order.serialNo.split("-")[0],
            productNo: order.productNo,
            color: order.color,
            sizeArrs: [
              {
                size: order.size,
                quantity: order.quantity,
                unit: order.unit,
              },
            ],
            subQuantity: order.quantity,
            unit: order.unit,
            customerProductNoArrs: [order.customerProductNo],
            handOverAt: order.handOverAt,
            remarkArrs: [order.remark],
            bomStr: productNoColorBoms.find(
              (b) => b.productNo == order.productNo && b.color == order.color
            ).bomStr,
          });
        } else {
          let sizeArrIndex = self.printSummaryDatas[
            printArrsIndex
          ].sizeArrs.findIndex((s) => s.size == order.size);
          if (sizeArrIndex == -1) {
            self.printSummaryDatas[printArrsIndex].sizeArrs.push({
              size: order.size,
              quantity: order.quantity,
              unit: order.unit,
            });
          } else {
            self.printSummaryDatas[printArrsIndex].sizeArrs[
              sizeArrIndex
            ].quantity =
              Number(order.quantity) +
              Number(
                self.printSummaryDatas[printArrsIndex].sizeArrs[sizeArrIndex]
                  .quantity
              );
          }
          //
          self.printSummaryDatas[printArrsIndex].subQuantity =
            Number(order.quantity) +
            Number(self.printSummaryDatas[printArrsIndex].subQuantity);
          //
          if (
            order.customerProductNo != null &&
            order.customerProductNo != "" &&
            !self.printSummaryDatas[
              printArrsIndex
            ].customerProductNoArrs.includes(order.customerProductNo)
          ) {
            self.printSummaryDatas[printArrsIndex].customerProductNoArrs.push(
              order.customerProductNo
            );
          }
          //
          if (
            order.remark != null &&
            order.remark != "" &&
            !self.printSummaryDatas[printArrsIndex].remarkArrs.includes(
              order.remark
            )
          ) {
            self.printSummaryDatas[printArrsIndex].remarkArrs.push(
              order.remark
            );
          }
        }
      }
      //每六个翻页
      self.printSummaryDatasGroup = [];
      for (var i = 0, len = self.printSummaryDatas.length; i < len; i += 6) {
        self.printSummaryDatasGroup.push(
          self.printSummaryDatas.slice(i, i + 6)
        );
      }
      // 尺码排序
      let sizeArr = [];
      for (const size of self.printSummarySizes) {
        let obj = self.sizes.find((s) => s.name == size);
        if (obj != null) {
          sizeArr.push({
            name: size,
            sequence: obj.sequence,
          });
        } else {
          sizeArr.push({
            name: size,
            sequence: null,
          });
        }
      }
      self.printSummarySizes = Util.objArraySort(sizeArr, "sequence").map(
        (s) => s.name
      );
    },
    getBargain(bargainId) {
      const self = this;
      Bargain.findById(bargainId).then(function (res) {
        if (res.data.code === 200) {
          self.bargain = res.data.entity;
        } else {
          self.sysError();
        }
      });
    },
    printFun(type) {
      if (this.printType.indexOf("NoMaterial") != -1) {
        this.printFunction("printSummaryNoMaterialDiv");
      } else {
        this.printFunction("printSummaryDiv");
      }
      this.printSummaryDF = false;
    },
    // 用料核算
    accountiMaterials() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const data = {
        type: "Order",
        uuids: self.selectRecords.map((c) => c.uuid),
      };
      Material.statistics(data).then(function (res) {
        if (res.status === 200) {
          if (res.data.length === 0) {
            self.$message({
              message: "暂无生成算料的数据",
              type: "warning",
            });
          } else {
            self.accountiMaterialsDF = true;
            self.datasAll = res.data;
            self.datas = res.data;
            // self.$router.push({
            //   name: "mmsCalculates",
            //   query: data,
            // });
          }
        } else {
          self.sysError();
        }
      });
    },
    //
    batchEditCostPrice() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.editCostPriceType = "batch";
      self.editCostPriceObj.costPrice = null;
      self.editCostPriceDF = true;
    },
    editCostPrice(row, rowIndex) {
      const self = this;
      self.editCostPriceType = "single";
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editCostPriceObj.costPrice = row.costPrice;
      self.editCostPriceDF = true;
    },
    editCostPriceSubmit() {
      const self = this;
      if (
        self.editCostPriceObj.costPrice != null &&
        self.editCostPriceObj.costPrice !== "" &&
        !Util.regexQuantity(self.editCostPriceObj.costPrice)
      ) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("orderMes.price")]),
          type: "warning",
        });
        return;
      }
      if (self.editCostPriceType == "batch") {
        self.editCostPriceDoing = true;
        OrderMes.batchUpdateCostPrice(
          self.selectRecords.map((s) => {
            return { id: s.id, costPrice: self.editCostPriceObj.costPrice };
          })
        ).then(function (res) {
          self.editCostPriceDoing = false;
          self.editCostPriceDF = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      } else {
        self.editCostPriceDoing = true;
        OrderMes.updateCostPrice(self.row.id, self.editCostPriceObj).then(
          function (res) {
            self.editCostPriceDoing = false;
            self.editCostPriceDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].costPrice =
                self.editCostPriceObj.costPrice;
            } else {
              self.sysError();
            }
          }
        );
      }
    },
    //
    editRemark(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editRemarkObj.remark = row.remark;
      self.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      OrderMes.updateRemark(self.row.id, self.editRemarkObj).then(function (
        res
      ) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.records[self.currentRowIdx].remark = self.editRemarkObj.remark;
        } else {
          self.sysError();
        }
      });
    },

    editMaterialRemark(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editMaterialRemarkObj.materialRemark = row.materialRemark;
      self.editMaterialRemarkDF = true;
    },
    editMaterialRemarkSubmit() {
      const self = this;
      self.editMaterialRemarkDoing = true;
      OrderMes.updateMaterialRemark(
        self.row.id,
        self.editMaterialRemarkObj
      ).then(function (res) {
        self.editMaterialRemarkDoing = false;
        self.editMaterialRemarkDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.records[self.currentRowIdx].materialRemark =
            self.editMaterialRemarkObj.materialRemark;
        } else {
          self.sysError();
        }
      });
    },
    // 重新派单
    swapSequence(row, rowIndex, type) {
      const self = this;
      const currentRowSequence = row.sequence;
      if (type == "up") {
        const currentRowUpSequence =
          self.phaseTemplatePhases[rowIndex - 1].sequence;
        self.phaseTemplatePhases[rowIndex].sequence = currentRowUpSequence;
        self.phaseTemplatePhases[rowIndex - 1].sequence = currentRowSequence;
      }
      if (type == "down") {
        const currentRowDownSequence =
          self.phaseTemplatePhases[rowIndex + 1].sequence;
        self.phaseTemplatePhases[rowIndex].sequence = currentRowDownSequence;
        self.phaseTemplatePhases[rowIndex + 1].sequence = currentRowSequence;
      }
      self.phaseTemplatePhases.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    },
    reDispatch(row) {
      const self = this;
      self.row = row;
      self.handmadeDispatchObj.type = "whole";
      self.handmadeDispatchObj.ids = [];
      self.handmadeDispatchObj.phaseTemplateItems = [];
      self.handmadeDispatchObj._selectedPhaseTemplateId = null;
      self.handmadeDispatchObj.day = null;
      PhaseTemplate.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.phaseTemplates = res.data;
          if (row.productId != null) {
            Product.productPhases(row.productId).then(function (res) {
              if (res.status === 200) {
                self.productPhases = res.data;
                self.phaseTemplatePhases = self.productPhases;
                self.handmadeDispatchDF = true;
              } else {
                self.sysError();
              }
            });
          } else {
            Phase.findByTenantId().then(function (res) {
              if (res.status === 200) {
                self.phases = res.data;
                self.phaseTemplatePhases = self.phases.map((p, pIndex) => {
                  return {
                    phaseId: p.id,
                    phaseHour: null,
                    period: null,
                    inspect: false,
                    tenantId: p.tenantId,
                    phaseName: p.name,
                    sequence: pIndex + 1,
                  };
                });
                self.handmadeDispatchDF = true;
              } else {
                self.sysError();
              }
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    selectPhaseTemplate() {
      const self = this;
      PhaseTemplate.findItems(
        self.handmadeDispatchObj._selectedPhaseTemplateId
      ).then(function (res) {
        if (res.status === 200) {
          self.phaseTemplatePhases = res.data;
        } else {
          self.sysError();
        }
      });
    },
    remove(row, rowIndex) {
      const self = this;
      self.phaseTemplatePhases.splice(rowIndex, 1);
    },
    handmadeDispatchSubmit() {
      const self = this;
      self.$refs.handmadeDispatchForm.validate((valid) => {
        if (valid) {
          self.handmadeDispatchObj.phaseTemplateItems =
            self.phaseTemplatePhases.filter(
              (c) =>
                c.phaseHour !== null &&
                c.phaseHour !== "" &&
                c.period !== null &&
                c.period !== ""
            );
          if (self.handmadeDispatchObj.phaseTemplateItems.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneValidDataFillIn"),
              type: "warning",
            });
            return;
          }
          for (const p of self.handmadeDispatchObj.phaseTemplateItems) {
            if (!Util.regexQuantity(p.phaseHour)) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("phaseTemplate.phaseHour"),
                ]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(p.period)) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("phaseTemplate.period"),
                ]),
                type: "warning",
              });
              return;
            }
          }
          if (self.handmadeDispatchObj.day == null) {
            self.handmadeDispatchObj.day = 0;
          }
          self.handmadeDispatchObj.day = -self.handmadeDispatchObj.day;
          self.handmadeDispatchObj.ids = [self.row.id];

          self.handmadeDispatchDoing = true;
          OrderMes.reManualDispatch(self.handmadeDispatchObj).then(function (
            res
          ) {
            self.handmadeDispatchDoing = false;
            self.handmadeDispatchDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.dispatchSuccess"),
                type: "success",
              });
              self.loadData();
              self.$eventHub.$emit("orderMesManualDispatch");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 回复生产
    reManufacture(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmReManufacture"))) {
        OrderMes.reManufacture(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.dealSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 暂停生产
    pause(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmPause"))) {
        OrderMes.pause(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.dealSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 取消
    cancel(row) {
      const self = this;
      WorkOrder.findByOrderUuid({ orderUuid: row.uuid }).then(function (res) {
        if (res.status === 200) {
          const workOrders = res.data;
          const workOrdersFilter = workOrders.filter((w) =>
            ["processed", "finished"].includes(w.workflowState)
          );
          if (workOrdersFilter.length === 0) {
            self.row = row;
            self.cancelObj.id = row.id;
            self.cancelObj.cancelReason = null;
            self.cancelDoing = false;
            self.cancelDF = true;
          } else {
            self.$message({
              message: self.$t("prompt.existProcessedAndFinishedWorkOrder"),
              type: "warning",
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    cancelSubmit() {
      const self = this;
      self.cancelDoing = true;
      OrderMes.cancel(self.row.id, self.cancelObj).then(function (res) {
        if (res.status === 200) {
          self.cancelDoing = false;
          self.cancelDF = false;
          self.$message({
            message: self.$t("prompt.cancelSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      if (row.specJson != null && row.specJson != "") {
        self.specJsonArrEdit = JSON.parse(row.specJson);
      }
      self.editObj.craftwork = row.craftwork;
      self.editObj.remark = row.remark;
      self.editDoing = false;
      self.editDF = true;
    },

    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          const specJsonArrEdit = self.specJsonArrEdit.filter(
            (sp) => sp.value != null
          );
          if (specJsonArrEdit.length !== 0) {
            self.editObj.specJson = JSON.stringify(specJsonArrEdit);
          }
          self.editDoing = true;
          OrderMes.simpleUpdate(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: this.selectRecords.map((c) => c.id),
        };
        this.downloadData(data);
      } else {
        if ((JSON.stringify(self.conditions) === "{}") === true) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      OrderMes.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    changeFactory(factory) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const vaildRows = this.selectRecords.filter((c) =>
        ["newly", "dispatched", "processing"].includes(c.workflowState)
      );
      if (vaildRows.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneValidData"));
        return;
      }

      OrderMes.changeFactory({
        factoryId: factory.id,
        factoryName: factory.name,
        ids: vaildRows.map((c) => c.id),
      }).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.changeFactorySuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("orderMesChangeFactory");
        } else {
          self.sysError();
        }
      });
    },

    batchAddGroup(group) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const obj = {
        ids: self.selectRecords.map((cb) => cb.id),
        groupJsons: [group],
      };
      self.joinGroupDoing = true;
      OrderMes.batchUpdateGroup(obj).then(function (res) {
        self.joinGroupDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addGroupSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    deleteGroup(row, rowIndex, group, groupIndex) {
      const self = this;
      const groupArr = JSON.parse(row.groupJsons);
      const groupJsonsArr = groupArr.filter((g) => g !== group);
      OrderMes.updateGroup(row.id, {
        groupJsons: JSON.stringify(groupJsonsArr),
      }).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.records[rowIndex].groupJsons = JSON.stringify(groupJsonsArr);
        } else {
          self.sysError();
        }
      });
    },
    //==
    narrowsFactoriesBrandsGroups() {
      this.narrows.push([
        {
          label: this.$t("menu.factories"),
          items: this.factories.map((factory) => {
            return {
              label: factory.name,
              key: factory.id,
              condition: { factoryId: factory.id },
            };
          }),
        },
        {
          label: this.$t("product.brand"),
          items: this.brands.map((brand) => {
            return {
              label: brand.name,
              key: brand.name,
              condition: { brand: brand.name },
            };
          }),
        },
        {
          label: this.$t("action.group"),
          items: this.groupsNarrow.map((group) => {
            return {
              label: group == "none" ? "无" : group,
              key: JSON.stringify(group),
              condition: {
                groupJson: group == "none" ? group : JSON.stringify(group),
              },
            };
          }),
        },
      ]);
    },

    showRecord(row) {
      this.currentRowUuid = row.uuid;
      this.currentRowId = row.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return OrderMes.search(params);
    },
    isNear(row) {
      //定义近交期
      if (
        ["newly", "processing"].includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      if (
        ["newly", "processing"].includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
